import React from 'react'
import BlogListItem from './list-item'
import { seededSample } from '../../utils/seeded-shuffle'

const BlogRelatedPostsSidebar = ({ heading = "Related insights", posts }) => {
    if (posts.length) {
        // Deterministic, SSR-safe seed derived from the posts themselves.
        const seed = posts.map((post) => (post && post.url) || '').join('|')
        return (
            <div className="c-article__related">
                <div className="c-article__related-title">{heading}</div>
                <div className="c-blog-listing c-blog-listing--article">
                    <div className="row">
                        {seededSample(posts, 3, seed).map((post, i) => {
                            return (
                                <BlogListItem key={post.url} post={post} hideSummary={true} />
                            )
                        })}
                    </div>
                </div>
            </div>
        )
    }

    return null
}

export default BlogRelatedPostsSidebar